import { useEffect, useState } from 'react';
import { useStoreSelector } from 'components/hooks/useStoreSelector';
import { useMapStoreContext } from './useMapStoreContext';
import { useApplicationRights } from 'components/hooks/useAppStore';
import { ApplicationRightService } from 'services/ApplicationRightService';
import { ReadRight as QuayManualReadRight } from '@pilot-web/quaymanuals';

export const useMapId = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.mapId);
};

export const useMapConfig = () => {
    const mapStore = useMapStoreContext();
    const config = useStoreSelector(mapStore, (state) => state.config);
    return config;
};
export const useSetMapConfig = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setConfig);
};

export const useMapZoom = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.zoom);
};
export const useSetMapZoom = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setZoom);
};

export const useMapCenter = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.center);
};
export const useSetMapCenter = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setCenter);
};

export const useMapBounds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.bounds);
};
export const useSetMapBounds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setBounds);
};

export const useMapDragStart = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.dragStart);
};
export const useSetMapDragStart = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setDragStart);
};

export const useMapDragEnd = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.dragEnd);
};
export const useSetMapDragEnd = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setDragEnd);
};

export const useMapResize = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.resize);
};
export const useSetMapResize = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setResize);
};

export const useMapClicked = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.mapClicked);
};
export const useSetMapClicked = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setMapClicked);
};

export const useShowAis = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showAis);
};

export const useIsAisActive = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.isAisActive);
};
export const useSetIsAisActive = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setIsAisActive);
};

export const useSegmentIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.segmentIds);
};
export const useSetSegmentIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSegmentIds);
};

export const useSegmentGroupIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.segmentGroupIds);
};
export const useSetSegmentGroupIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSegmentGroupIds);
};

export const usePilotageLoaded = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.pilotageLoaded);
};
export const useSetPilotageLoaded = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setPilotageLoaded);
};

export const useShipPositionLoaded = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.shipPositionLoaded);
};
export const useSetShipPositionLoaded = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShipPositionLoaded);
};

export const useSelectShipPosition = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.selectShipPosition);
};
export const useSetSelectShipPosition = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSelectShipPosition);
};

export const useShowInfo = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showInfo);
};
export const useSetShowInfo = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowInfo);
};

export const useShowDialog = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showDialog);
};
export const useSetShowDialog = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowDialog);
};

export const useSelectLocation = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.selectLocation);
};
export const useSetSelectLocation = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSelectLocation);
};

export const useShowLocations = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showLocations);
};
export const useSetShowLocations = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowLocations);
};

export const useActivateSeamap = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.activateSeamap);
};
export const useSetActivateSeamap = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setActivateSeamap);
};

export const useShowLegend = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showLegend);
};
export const useSetShowLegend = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowLegend);
};

export const useShowLoader = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showLoader);
};
export const useSetShowLoader = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowLoader);
};

export const useDataClicked = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.dataClicked);
};
export const useSetDataClicked = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setDataClicked);
};

export const useActivateMultiSelect = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.activateMultiSelect);
};
export const useSetActivateMultiSelect = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setActivateMultiSelect);
};

export const useFeatureMouseOver = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.featureMouseOver);
};
export const useSetFeatureMouseOver = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setFeatureMouseOver);
};

export const useFeatureMouseOut = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.featureMouseOut);
};
export const useSetFeatureMouseOut = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setFeatureMouseOut);
};

export const usePanelState = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.panelState);
};
export const useSetPanelState = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setPanelState);
};

export const useMapTitle = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.mapTitle);
};
export const useSetMapTitle = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setMapTitle);
};

export const useSelectedCoastalSegmentGroup = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.selectedCoastalSegmentGroup);
};
export const useSetSelectedCoastalSegmentGroup = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSelectedCoastalSegmentGroup);
};

export const useSelectedLocation = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.selectedLocation);
};
export const useSetSelectedLocation = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setSelectedLocation);
};

export const usePilotCertificateCoastalSegmentPerson = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.pilotCertificateCoastalSegmentPerson);
};
export const useSetPilotCertificateCoastalSegmentPerson = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setPilotCertificateCoastalSegmentPerson);
};

export const useExcludeLocationIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.excludeLocationIds);
};
export const useSetExcludeLocationIds = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setExcludeLocationIds);
};

export const useShowLocationType = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showLocationType);
};
export const useSetShowLocationType = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowLocationType);
};

export const useCoastalSegmentGroups = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.coastalSegmentGroups);
};
export const useSetCoastalSegmentGroups = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setCoastalSegmentGroups);
};

export const useShowLocationQuayManual = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.showLocationQuayManual);
};
export const useSetShowLocationQuayManual = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setShowLocationQuayManual);
};

export const usePilotCertificateToggleFeatures = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.pilotCertificateToggleFeatures);
};
export const useSetPilotCertificateToggleFeatures = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.setPilotCertificateToggleFeatures);
};

export const useSelectedPilotCoastalSegmentGroup = () => {
    const mapStore = useMapStoreContext();
    return useStoreSelector(mapStore, (state) => state.selectedPilotCoastalSegmentGroup);
};
export const useSetSelectedPilotCoastalSegmentGroup = () => {
    const mapStore = useMapStoreContext();
    const setSelectedPilotCoastalSegmentGroup = useStoreSelector(mapStore, (state) => state.setSelectedPilotCoastalSegmentGroup);

    const onHandle = (data: any | null) => {
        setSelectedPilotCoastalSegmentGroup(data);
        setTimeout(() => {
            setSelectedPilotCoastalSegmentGroup(null);
            }, 100);
    }
    return onHandle;
};

export const useHasQuayManualAccess = () => {

    const applicationRights = useApplicationRights();
    const [hasQuayManualAccess, setHasQuayManualAccess ] = useState(false);

    useEffect(() => {
        if (!applicationRights || applicationRights.length === 0) return;

        const applicationRightService = new ApplicationRightService(applicationRights);
        setHasQuayManualAccess(applicationRightService.canAccess([QuayManualReadRight]));

    }, [applicationRights]);

    return { hasQuayManualAccess };
}
